import { getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleTextInput from '../../components/ModuleTextInput';
import { WORKING_ON_NODE_DATA } from '../../../EditablePreview/VisualisedComponents/VisualisedNode';

const TextAreaField = (props) => {
    const fieldData = props.fieldData;
    const customisationVars = props.customisationVars;


    return (
        <>
            <div className={`v2-module-field-label${!props.isEnabled ? ' disabled' : ''}`}>{fieldData?.customFieldConfig?.customFieldLabel ?? 'String'}</div>
            <ModuleTextInput
                value={getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)}
                fieldId={'text-area-field'}
                enabled={props.isEnabled}
                editable={true}
                multiline={true}
                onChange={
                    (fieldId, value) => {
                        WORKING_ON_NODE_DATA.fieldData = fieldData;
                        WORKING_ON_NODE_DATA.node = props.selectedFeatureNode;
                        updateCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
                        props?.forceUpdateComponent?.();
                    }
                }
            />
        </>
    );
};

export default TextAreaField;
